import { useRouteError, isRouteErrorResponse } from "react-router";
import AccessDeniedNotice from "../components/errors/AccessDeniedNotice.jsx";

export default function RouteErrorBoundary() {
  const error = useRouteError();

  if (
    isRouteErrorResponse(error) &&
    (error.status === 404 || error.status === 403)
  ) {
    return <AccessDeniedNotice status={error.status} />;
  }

  const message = isRouteErrorResponse(error)
    ? error.statusText
    : error instanceof Error
      ? error.message
      : null;

  return (
    <AccessDeniedNotice
      status={isRouteErrorResponse(error) ? error.status : null}
      message={message}
    />
  );
}
